import { metricKeys } from '@pulse/metrics';

export const betaMetricList = [
  metricKeys.AppServicePerformanceIndex,
  metricKeys.rage_click_count,
  metricKeys.user_session_with_rage_click,
  metricKeys.users_with_rage_click,
  metricKeys.user_session_with_app_restart,
  metricKeys.excessive_app_restart_count,
  metricKeys.page_loop_count,
  metricKeys.user_session_with_page_loop,
  metricKeys.users_with_page_loop,
  metricKeys.page_not_consumed_count,
  metricKeys.user_session_with_page_not_consumed,
  metricKeys.users_with_page_not_consumed,
  metricKeys.user_session_with_anr,
  metricKeys.user_session_with_app_crash,
  metricKeys.click_to_error_success,
  metricKeys.users_with_click_to_error,
  metricKeys.user_session_with_click_to_error,
  metricKeys.users_with_anr,
  metricKeys.users_with_app_crash,
  metricKeys.nw_5xx_to_app_background_success,
  metricKeys.nw_5xx_to_app_background_success_rate,
  metricKeys.users_with_order_confirmed,
  metricKeys.users_with_order_confirmed_percentage,
  metricKeys.session_with_order_confirmed,
  metricKeys.session_with_order_confirmed_percentage,
  metricKeys.users_with_add_to_cart,
  metricKeys.users_with_add_to_cart_percentage,
  metricKeys.session_with_add_to_cart,
  metricKeys.session_with_add_to_cart_percentage,
  metricKeys.users_with_checkout_start,
  metricKeys.users_with_checkout_start_percentage,
  metricKeys.session_with_checkout_start,
  metricKeys.session_with_checkout_start_percentage,
  metricKeys.app_crash_v2_count,
  metricKeys.UniqueViewersWithAttempts,
  metricKeys.UniqueViewersWithEndedPlays,
  metricKeys.AdUniqueViewersWithEndedPlays,
  metricKeys.EndingBitrate,
  metricKeys.VideoPlaybackFailuresTechPer1000PlayingMinutes,
];

export const deprecationMetricList = [metricKeys.AvgPerceivedLoadingTime];

export const deprecatingSoon = [];
